<p-progressSpinner
  *ngIf="loading$ | async"
  styleClass="app-spinner"
  [style]="{ width: '50px', height: '50px' }"
  strokeWidth="4"
></p-progressSpinner>
<!-- <app-spinner></app-spinner> -->
<router-outlet />
<p-confirmDialog></p-confirmDialog>
<app-connection-alert></app-connection-alert>
